import { render, staticRenderFns } from "./Benefit.vue?vue&type=template&id=6edca920&scoped=true"
import script from "./Benefit.vue?vue&type=script&lang=js"
export * from "./Benefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edca920",
  null
  
)

export default component.exports